import React from "react";

import FileDownloadOutlined from "@mui/icons-material/FileDownloadOutlined";
import { Button } from "components";
import Modal from "components/UI/Modal/Modal";

import styles from "styles/pages/ModalActions.module.scss";

const FIELDS = [
    { orden: 1, campo: "tipoDeDocumentoCod", formato: "texto(10)", ejemplo: "DNI", descripcion: "Tipo de documento del usuario" },
    { orden: 2, campo: "usuarioNroDeDocumentoX", formato: "texto(30)", ejemplo: "12345678", descripcion: "Número de documento del usuario" },
    { orden: 3, campo: "usuarioSexo", formato: "texto(1)", ejemplo: "M", descripcion: "Género del usuario. Depende del tipo de Documento (Consultar)" },
    { orden: 4, campo: "usuarioFechaDeNacimiento", formato: "fecha(YYYY-MM-DD)", ejemplo: "1990-01-15", descripcion: "Fecha de nacimiento del usuario" },
    { orden: 5, campo: "usuarioApellidos", formato: "texto(75)", ejemplo: "Pérez", descripcion: "Apellidos del usuario" },
    { orden: 6, campo: "usuarioNombres", formato: "texto(50)", ejemplo: "Juan", descripcion: "Nombres del usuario" },
    { orden: 7, campo: "usuarioMail", formato: "texto(150)", ejemplo: "juan.perez@example.com", descripcion: "Correo electrónico del usuario" },
    { orden: 8, campo: "novedadFecha", formato: "fecha(YYYY-MM-DD)", ejemplo: "2023-01-01", descripcion: "Fecha desde cuando aplica (≥ fecha actual)" },
    { orden: 9, campo: "novedadTipo", formato: "texto(1)", ejemplo: "A", descripcion: "Tipo de novedad: A(Alta), B(Baja)" },
    { orden: 10, campo: "lugarCod", formato: "texto(10)", ejemplo: "L01", descripcion: "Código del lugar de acceso" },
    { orden: 11, campo: "horarioCod", formato: "texto(10)", ejemplo: "H01", descripcion: "Código del horario" },
];

const downloadTemplate = () => {
    const headers = FIELDS.map((f) => `"${f.campo}"`).join(",");
    const example = FIELDS.map((f) => `"${f.ejemplo}"`).join(",");
    const content = `${headers}\n${example}\n`;

    const blob = new Blob([content], { type: "text/csv;charset=utf-8;" });
    const url = window.URL.createObjectURL(blob);
    const link = document.createElement("a");
    link.href = url;
    link.download = "PlantillaHorarios.csv";
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    window.URL.revokeObjectURL(url);
};

export default function CSVFieldsInfoModal({ open, onClose }) {
    return (
        <Modal open={open} title="Detalle de campos del CSV" onClose={onClose}>
            <div className={styles.inputs}>
                <table className={styles["fields-table"]}>
                    <thead>
                        <tr>
                            <th>#</th>
                            <th>Campo</th>
                            <th>Formato</th>
                            <th>Ejemplo</th>
                            <th>Descripción</th>
                        </tr>
                    </thead>
                    <tbody>
                        {FIELDS.map((f) => (
                            <tr key={f.campo}>
                                <td>{f.orden}</td>
                                <td><code>{f.campo}</code></td>
                                <td>{f.formato}</td>
                                <td>"{f.ejemplo}"</td>
                                <td>{f.descripcion}</td>
                            </tr>
                        ))}
                    </tbody>
                </table>
                <div className={styles["actions-row"]} style={{ marginTop: "1rem" }}>
                    <Button className={styles.defaultBtn} onClick={downloadTemplate}>
                        <FileDownloadOutlined fontSize="small" style={{ marginRight: "0.4rem" }} />
                        Ejemplo CSV
                    </Button>
                </div>
            </div>
        </Modal>
    );
}
